














































































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../system/mixins";
import { LightTable, LightRow } from "../../../../domain/system/table";
import { DomainRegistry } from "../../../../domain";
import LightScrollableTable from "./LightScrollableTable.vue";
import { UserDefinitionSelectResult } from "./UserDefinitionSelectResult";
import { UserDefinitionSelectItem } from "./UserDefinitionSelectItem";
import { UserDefinitionTextFilterKinds } from "./UserDefinitionTextFilterKinds";
import { UserDefinitionFilterPatternKinds } from "./UserDefinitionFilterPatternKinds";
import { IConfiguration } from "../../../../domain/configuration";
import { InstitutionItem } from "../../../../domain/institution";
import FixedLoading from "../../../system/FixedLoading.vue";

@Component({
  components: {
    LightScrollableTable,
    FixedLoading,
  },
})
export default class InstitutionSelectDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      result: null as UserDefinitionSelectResult,
      sourceTable: null as LightTable,
      destinationTable: null as LightTable,
      allTable: null as LightTable,
      patientId: null as string,
      textFilter: UserDefinitionTextFilterKinds.Contains,
      textFilterStartsWith: UserDefinitionTextFilterKinds.StartsWith,
      textFilterContains: UserDefinitionTextFilterKinds.Contains,
      filterPattern: UserDefinitionFilterPatternKinds.And,
      filterPatternAnd: UserDefinitionFilterPatternKinds.And,
      filterPatternOr: UserDefinitionFilterPatternKinds.Or,
      enableHalfDistinction: this.shouldDistinguishCharacterWidth(),
    };
  }
  result: UserDefinitionSelectResult;
  sourceTable: LightTable;
  destinationTable: LightTable;
  allTable: LightTable;
  patientId: string;
  textFilter: UserDefinitionTextFilterKinds;
  filterPattern: UserDefinitionFilterPatternKinds;
  enableHalfDistinction: boolean;

  get isEmpty(): boolean {
    return (!this.sourceTable || !this.destinationTable || !this.allTable);
  }

  get isSelected(): boolean {
    return !this.isEmpty && (this.sourceTable.isSelected || this.destinationTable.isSelected || this.allTable.isSelected);
  }

  async show(key: string, patientId: string): Promise<UserDefinitionSelectResult> {
    return this.showModal(async () => {
      this.collectGarbage();
      this.patientId = patientId;
      this.sourceTable = null;
      this.destinationTable = null;
      this.allTable = null;
      this.result = null;
      const repository = DomainRegistry.institution.getInstitutionRepository();
      repository.getPatientRelatedInstitutionInformation(key, patientId)
      .then(info => {
        this.allTable = info.allInstitutionTable;
        this.sourceTable = info.sourceInstitutionTable;
        this.destinationTable = info.destinationInstitutionTable;
      }).catch(e => {
        this.$error("エラー", "施設情報の取得に失敗しました。", e);
      });
      await this.waitHidden();
      this.sourceTable = null;
      this.destinationTable = null;
      this.allTable = null;
      this.collectGarbage();
      return this.result;
    });
  }

  collectGarbage(): void {
    // IEでのメモリリーク対策
    const castedWindow = window as any;
    if (castedWindow.CollectGarbage) {
        castedWindow.CollectGarbage();
    }
  }

  getResult(): UserDefinitionSelectResult {
    const headers = this.allTable.headers;
    const items: UserDefinitionSelectItem[] = [];
    for (let cellIndex = 0; cellIndex < headers.length; ++cellIndex) {
      const values: string[] = [];
      Array.prototype.push.apply(values, this.sourceTable.getSelectedValuesByCellIndex(cellIndex));
      Array.prototype.push.apply(values, this.destinationTable.getSelectedValuesByCellIndex(cellIndex));
      Array.prototype.push.apply(values, this.allTable.getSelectedValuesByCellIndex(cellIndex));
      const header = headers[cellIndex];
      const item = new UserDefinitionSelectItem();
      item.name = header.value;
      item.values = values;
      items.push(item);
    }
    const result = new UserDefinitionSelectResult();
    result.items = items;
    result.institution = this.getSelectedInstitution();
    return result;
  }

  setResultAndClose(): void {
    this.$nextTick(() => this.select());
  }

  select(): void {
    if (!this.isSelected) { return; }
    this.result = this.getResult();
    this.isVisible = false;
  }
  
  cancel(): void {
    this.result = null;
    this.isVisible = false;
  }

  onSourceTableClickerd(): void {
    this.destinationTable.clearSelection();
    this.allTable.clearSelection();
  }

  onDestinationTableClickerd(): void {
    this.sourceTable.clearSelection();
    this.allTable.clearSelection();
  }

  onAllTableClickerd(): void {
    this.sourceTable.clearSelection();
    this.destinationTable.clearSelection();
  }

  getSelectedRows(): LightRow[] {
    const rows: LightRow[] = [];
    Array.prototype.push.apply(rows, this.sourceTable.selectedRows);
    Array.prototype.push.apply(rows, this.destinationTable.selectedRows);
    Array.prototype.push.apply(rows, this.allTable.selectedRows);
    return rows;
  }

  getSelectedInstitution(): InstitutionItem {
    const rows = this.getSelectedRows();
    return rows.length > 0
      ? new InstitutionItem(rows[0])
      : null;
  }

  shouldDistinguishCharacterWidth(): boolean {
    return this.$store.getters.configuration.behavior.document.editor.userDefinition.filter.default.shouldDistinguishCharacterWidth;
  }

  get rowCountPerPage(): number {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.document.editor.userDefinition.displayCountPerPage;
  }
}
